import * as React from 'react'
import { ErrorBase } from './ErrorBase'
import { useTranslation } from 'i18n'

export const Error500: React.FC = () => {
  const { t } = useTranslation('standalone.error')
  return <ErrorBase title={t('error')} description={t('500description')} />
}
